import { dayjs } from 'src/lib/dayjs'

export function formatSecondsAsTimestamp(timestamp: number) {
  return dayjs.duration(timestamp, 's').format(timestamp >= 3600 ? 'H:mm:ss' : 'm:ss')
}
